/*
 * SOPHIOR · sophior-leverdag.js (redesign Het Werkblad, s03-zekerheden, golf 1).
 * De echte leverdag in Nederlandse tijd (D06 §3.2, 09 §3, KENNISFEITEN §1
 * "Leverdag"): V = eerste verzenddag vanaf vandaag (vandaag alleen vóór de
 * besteltijd), L = eerste bezorgdag na V. Zin: "Vandaag besteld, [dag] in huis." (besluit
 * JP 3 nov 2026). Besteltijd: ma t/m do 22:00, vrijdag 20:00 (instellingen
 * sophior_leverdag_afkapping en _afkapping_vr). Alleen met sophior_uitrol_leverdag aan, land NL, niet zakelijk,
 * niet bij pre-order, nooit in of vlak vóór een kerstvenster. Geen afteller.
 * Ook geen dag zodra de klant een extra op pre-order kiest (pakket, compleet of
 * het add-onvinkje van de huidige buybox); in de bestaande regels (haak) alleen
 * de canonieke zin vervangen, de rest van de tekst blijft (codereview golf 1).
 * Data: #sophior-leverkalender (snippets/sophior-leverkalender-data.liquid).
 * Tijdmock: ?sophior_nu=2026-12-24T16:30, alleen op een niet-gepubliceerd thema.
 * API: window.SophiorLeverdag = { staat(variantId, el), ververs(root), bereken(nu) }.
 * Interface en tests: docs/redesign-2026/06-bouw/stromen/s03-zekerheden-golf1.md.
 */
(function () {
  'use strict';
  if (window.SophiorLeverdag) return;

  var DAG = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var KORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var MAAND = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var MAAND_KORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var SEL = '[data-sophior-leverdag]';
  var cfg = null;
  var mock = null;
  var correctie = null;
  var timer = null;
  var orig = new WeakMap();
  var laatst = new WeakMap();
  var variantStaat = new WeakMap();

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dagen(lijst) {
    return String(lijst || '').toLowerCase().split(',').map(function (d) { return KORT.indexOf(d.trim()); }).filter(function (i) { return i > -1; });
  }
  function dagnr(y, m, d) { return Math.floor(Date.UTC(y, m - 1, d) / 864e5); }
  function wd(n) { return new Date(n * 864e5).getUTCDay(); }
  function iso(n) { var d = new Date(n * 864e5); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function voluit(n) { var d = new Date(n * 864e5); return DAG[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MAAND[d.getUTCMonth()]; }
  function kortDag(n) { var d = new Date(n * 864e5); return KORT[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MAAND_KORT[d.getUTCMonth()]; }
  function wand(t) { return t.y + '-' + pad(t.m) + '-' + pad(t.d) + 'T' + pad(t.h) + ':' + pad(t.mi); }

  function parse(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(String(s || ''));
    return m ? { y: +m[1], m: +m[2], d: +m[3], h: +m[4], mi: +m[5] } : null;
  }

  /* De besteltijd van een besteldag in minuten na middernacht. Vrijdag heeft een
     eigen, vroegere grens (besluit JP 3 nov 2026: ma t/m do 22:00, vr 20:00). */
  function afkapMin(dag) {
    var vr = dag === 5;
    var s = (vr && cfg.afkapVr) ? cfg.afkapVr : (cfg.afkap || '22:00');
    var af = String(s).split(':');
    var m = parseInt(af[0], 10) * 60 + (parseInt(af[1], 10) || 0);
    /* Tikfout in de instelling: de standaardgrens van die dag, nooit de ruimste
       (hooguit later, nooit te vroeg; codereview 3 nov). */
    return (isNaN(m) || m < 0 || m > 1439) ? (vr ? 1200 : 1320) : m;
  }

  function nlDelen(ms) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
      return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute };
    } catch (e) {
      return null;
    }
  }

  function nu() {
    if (mock) return mock;
    return nlDelen(correctie !== null ? correctie + performance.now() : Date.now());
  }

  /* De beslisregel. t = Nederlandse tijd als delen, of een string 2026-12-24T16:30.
     Uitkomst: 'pauze' (binnen een kerstvenster; tekst = pauzetekst of leeg),
     'a' (morgen in huis), 'b' (in huis op een latere dag) of 'c' (de vaste zin). */
  function bereken(t) {
    if (typeof t === 'string') t = parse(t);
    t = t || nu();
    if (!t || !cfg) return { uitkomst: 'c' };
    var w = wand(t);
    var vs = cfg.vensters || [];
    var i;
    for (i = 0; i < vs.length; i++) {
      if (w >= vs[i].start && w < vs[i].eind) return { uitkomst: 'pauze', tekst: vs[i].lang || '' };
    }
    if (!cfg.aan) return { uitkomst: 'c' };
    var vandaag = dagnr(t.y, t.m, t.d);
    var verzend = dagen(cfg.verzend);
    var bezorg = dagen(cfg.bezorg);
    if (dagen(cfg.noemen).indexOf(wd(vandaag)) < 0 || !verzend.length || !bezorg.length) return { uitkomst: 'c' };
    var na = t.h * 60 + t.mi >= afkapMin(wd(vandaag));
    var V = vandaag;
    for (i = 0; i < 14 && (verzend.indexOf(wd(V)) < 0 || (V === vandaag && na)); i++) V++;
    var L = V + 1;
    for (i = 0; i < 14 && bezorg.indexOf(wd(L)) < 0; i++) L++;
    /* Een venster dat vóór de bezorgdag begint en nog loopt: geen dag noemen
       (hooguit later, nooit te vroeg). */
    var Ld = iso(L);
    for (i = 0; i < vs.length; i++) {
      if (vs[i].eind > w && vs[i].start.slice(0, 10) < Ld) return { uitkomst: 'c' };
    }
    return { uitkomst: L === vandaag + 1 ? 'a' : 'b', dag: voluit(L), kort: kortDag(L), datum: Ld };
  }

  function staat(variantId, el) {
    if (el && variantId) {
      try {
        var m = JSON.parse(el.getAttribute('data-varianten') || '{}');
        if (m[String(variantId)]) return m[String(variantId)];
      } catch (e) { /* geen kaart */ }
    }
    return el ? (variantStaat.get(el) || el.getAttribute('data-staat') || 'voorraad') : 'voorraad';
  }

  function datumOk(d) { return /^rond /.test(String(d || '')); }

  /* Een gekozen extra op pre-order in dezelfde sectie (codereview golf 1, M2):
     een aangevinkte [data-addon-checkbox] waarvan het [data-addon-block] op
     pre-order staat. Het B1-bestelblad zet data-staat op de pakket- en
     compleet-opties; de huidige add-onkaart draagt het pre-orderlabel
     (.sophior-product-info__addon-preorder, bestaande markup). Leest de DOM van
     de eigen sectie, dus ook na een terugknop met herstelde vinkjes; het event
     sophior:pakket-change (B1) is alleen de aanleiding om opnieuw te kiezen.
     Geeft null of { staat: 'preorder', verzenddatum }. */
  function extraPreorder(el) {
    var scope = (el && el.closest && el.closest('.shopify-section')) || document;
    var uit = null;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-addon-block]'), function (blok) {
      var inp = blok.matches('[data-addon-checkbox]') ? blok : blok.querySelector('[data-addon-checkbox]');
      if (!inp || !inp.checked) return;
      if (blok.getAttribute('data-staat') !== 'preorder' && !blok.querySelector('.sophior-product-info__addon-preorder')) return;
      uit = uit || { datums: [], zonder: false };
      var d = blok.getAttribute('data-verzenddatum') || '';
      if (!d) uit.zonder = true;
      else if (uit.datums.indexOf(d) < 0) uit.datums.push(d);
    });
    return uit ? { staat: 'preorder', verzenddatum: (!uit.zonder && uit.datums.length === 1) ? uit.datums[0] : '' } : null;
  }

  /* Wat er op regel 1 moet staan: { html: null } = de server-side tekst terug,
     { tekst } = een vaste zin, { sjabloon, waarde, datum } = een zin met de dag.
     Bij de haak alleen de canonieke zin binnen de bestaande tekst vervangen
     (vervang), nooit de hele tekst (codereview golf 1, M1). */
  function keuze(el) {
    var ctx = el.getAttribute('data-context');
    var st = staat(null, el);
    var nl = el.getAttribute('data-land') === 'NL' && !el.hasAttribute('data-b2b');
    var r = bereken();
    var t = cfg.t || {};

    if (ctx === 'drawer' && el.getAttribute('data-staat') === 'gemengd') return { html: null };
    if (ctx === 'haak') {
      /* Met een extra op pre-order nooit een dag: de servertekst blijft (M2). */
      if (st !== 'voorraad' || !nl || extraPreorder(el) || (r.uitkomst !== 'a' && r.uitkomst !== 'b')) return { html: null };
      return { sjabloon: r.uitkomst === 'a' ? t.morgen : t.op, waarde: r.dag, datum: r.datum, vervang: t.canoniek, vervangKort: t.kort, sjabloonKort: t.sticky, waardeKort: r.kort };
    }
    if (ctx === 'regel') {
      var vd = el.getAttribute('data-verzenddatum');
      var po = st === 'voorraad' ? extraPreorder(el) : null;
      if (po) {
        /* Een extra op pre-order: nooit een dag (M2). RG-05 alleen met
           _preorder_zin en samen verzenden aan; anders de servertekst. */
        if (!cfg.zin || !cfg.samen) return { html: null };
        return datumOk(po.verzenddatum) ? { sjabloon: t.mix_datum, waarde: po.verzenddatum, token: '[verzenddatum]' } : { tekst: t.mix };
      }
      if (st === 'preorder') {
        return datumOk(vd) ? { sjabloon: t.po_datum, waarde: vd, token: '[verzenddatum]' } : { tekst: t.po };
      }
      if (st !== 'voorraad') return { tekst: '' };
    }
    if (r.uitkomst === 'pauze') return r.tekst ? { tekst: r.tekst } : { tekst: t.canoniek };
    if (nl && (r.uitkomst === 'a' || r.uitkomst === 'b')) {
      return { sjabloon: r.uitkomst === 'a' ? t.morgen : t.op, waarde: r.dag, datum: r.datum };
    }
    return { tekst: t.canoniek };
  }

  /* De zin met de dag als fragment: tekst, <time> (of tekst) en de rest.
     zonderPunt: de bestaande regel eindigt zonder punt (de sticky leverregel). */
  function zin(k, zonderPunt) {
    var token = k.token || '[dag]';
    var delen = String(k.sjabloon).split(token);
    var rest = delen.slice(1).join(token);
    if (zonderPunt) rest = rest.replace(/\.$/, '');
    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode(delen[0] || ''));
    var waarde;
    if (k.datum) {
      waarde = document.createElement('time');
      waarde.setAttribute('datetime', k.datum);
      waarde.textContent = k.waarde;
    } else {
      waarde = document.createTextNode(k.waarde);
    }
    frag.appendChild(waarde);
    frag.appendChild(document.createTextNode(rest));
    return frag;
  }

  /* Zoals innerHTML tekst serialiseert, zodat de canonieke zin in de opgeslagen
     servertekst te vinden is. */
  function alsHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ /g, '&nbsp;');
  }

  /* N-02 (kleine ronde 22 okt 2026): een regel met data-leverdag-reserveer (de
     collectiekop van B3) houdt bij de wissel de hoogte vast die hij op dat moment
     heeft (min-height in px, inline): een kortere dagzin schuift chiprij en
     raster dan niet omhoog, op elke breedte, ook op korte schermen en met de
     actievorm van de verzendzin. Komt Inter pas na de wissel binnen, dan staat de
     servertekst er niet meer en groeit er niets (op slow 4G gemeten op 360 px);
     alleen een dagzin die in Inter meer regels heeft dan de servertekst in het
     terugvallettertype kan dan nog een regel groeien, zoals zonder deze regel.
     Geen CSS en geen nieuw breekpunt nodig (D01 §5.8 regel 10). Verandert
     de schermbreedte (draaien), dan laat de regel weer los; een hoogteverandering
     (de adresbalk bij scrollen) niet. Zonder het attribuut verandert er niets. */
  var vastgezet = [];
  var vastBreedte = window.innerWidth;
  function zetVast(el) {
    if (!el.hasAttribute('data-leverdag-reserveer') || el.style.minHeight) return;
    var h = el.getBoundingClientRect().height;
    if (!h) return;
    el.style.minHeight = h + 'px';
    vastgezet.push(el);
  }
  window.addEventListener('resize', function () {
    if (window.innerWidth === vastBreedte) return;
    vastBreedte = window.innerWidth;
    vastgezet.forEach(function (el) { el.style.minHeight = ''; });
    vastgezet = [];
  });

  function teken(el) {
    var doel = el.matches('[data-leverdag-tekst]') ? el : el.querySelector('[data-leverdag-tekst]');
    if (!doel || !cfg) return;
    if (!orig.has(doel)) orig.set(doel, doel.innerHTML);
    var k = keuze(el);
    var sleutel = JSON.stringify(k);
    if (laatst.get(doel) === sleutel) return;
    laatst.set(doel, sleutel);
    zetVast(el);

    if (k.html === null) {
      doel.innerHTML = orig.get(doel);
      return;
    }
    if (!k.sjabloon) {
      doel.textContent = k.tekst || '';
      return;
    }
    if (k.vervang) {
      /* Haak (M1): alleen de canonieke zin binnen de servertekst vervangen, zodat
         bijvoorbeeld "Gratis verzending vanaf €59." ervoor blijft staan. Eerst met
         punt, dan zonder (de sticky leverregel heeft geen punt). Staat de zin er
         niet letterlijk in, dan blijft de servertekst. */
      var html = orig.get(doel);
      var vind = alsHtml(k.vervang);
      var pos = html.indexOf(vind);
      var zonderPunt = false;
      if (pos < 0 && /\.$/.test(vind)) {
        vind = vind.slice(0, -1);
        pos = html.indexOf(vind);
        zonderPunt = pos > -1;
      }
      /* De korte vorm (sticky koopbalk): zonder slotpunt in de locale. Staat er
         toch een punt achter, dan die meenemen, zodat er geen dubbele punt komt. */
      var viaKort = false;
      if (pos < 0 && k.vervangKort) {
        vind = alsHtml(k.vervangKort);
        pos = html.indexOf(vind);
        viaKort = pos > -1;
        if (pos > -1 && html.charAt(pos + vind.length) === '.') {
          vind += '.';
          zonderPunt = false;
        } else {
          zonderPunt = pos > -1;
        }
      }
      if (pos < 0) {
        doel.innerHTML = html;
        return;
      }
      doel.innerHTML = html.slice(0, pos) + '<span data-leverdag-plek></span>' + html.slice(pos + vind.length);
      var plek = doel.querySelector('[data-leverdag-plek]');
      /* De korte vorm staat in de smalle sticky koopbalk (±170 px op 375): daar de
         compacte zin "In huis op wo 4 nov" (locale sticky_dag), anders kapt de
         ellips de datum af (3 nov 2026). */
      var kz = (viaKort && k.sjabloonKort) ? { sjabloon: k.sjabloonKort, waarde: k.waardeKort || k.waarde, datum: k.datum } : k;
      if (plek) plek.parentNode.replaceChild(zin(kz, zonderPunt), plek);
      return;
    }
    doel.textContent = '';
    doel.appendChild(zin(k, false));
  }

  function ververs(root) {
    if (!cfg) return;
    var scope = root && root.querySelectorAll ? root : document;
    var lijst = scope.querySelectorAll(SEL);
    Array.prototype.forEach.call(lijst, teken);
    if (scope.matches && scope.matches(SEL)) teken(scope);
  }

  /* Eén timer naar het eerstvolgende moment waarop de uitkomst kan omslaan:
     de besteltijd, middernacht, of het begin of einde van een venster. */
  function plan() {
    if (timer) clearTimeout(timer);
    if (mock || !cfg) return;
    var t = nu();
    if (!t) return;
    var minNu = dagnr(t.y, t.m, t.d) * 1440 + t.h * 60 + t.mi;
    var vandaag = dagnr(t.y, t.m, t.d);
    var kandidaten = [(vandaag + 1) * 1440];
    var afMin = vandaag * 1440 + afkapMin(wd(vandaag));
    if (afMin > minNu) kandidaten.push(afMin);
    (cfg.vensters || []).forEach(function (v) {
      [v.start, v.eind].forEach(function (s) {
        var p = parse(s);
        if (p) {
          var m = dagnr(p.y, p.m, p.d) * 1440 + p.h * 60 + p.mi;
          if (m > minNu) kandidaten.push(m);
        }
      });
    });
    var wacht = Math.min.apply(Math, kandidaten) - minNu;
    var ms = Math.min(wacht * 6e4 - (Date.now() % 6e4) + 500, 864e5);
    timer = setTimeout(function () { ververs(); plan(); }, Math.max(ms, 1000));
  }

  function start() {
    var el = document.getElementById('sophior-leverkalender');
    if (!el) return;
    try {
      cfg = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }

    var test = cfg.editor || (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
    if (test) {
      try {
        mock = parse(new URLSearchParams(location.search).get('sophior_nu'));
      } catch (e) { mock = null; }
    }

    /* Klokcontrole: wijkt de toestelklok meer dan de marge af van de servertijd,
       dan rekenen we met servertijd plus de verstreken tijd. */
    var server = (cfg.server || 0) * 1000;
    if (server && Math.abs(Date.now() - server) > (cfg.marge || 6) * 36e5) {
      correctie = server - performance.now();
    }

    ververs();
    plan();

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { ververs(); plan(); }
    });
    ['sophior:cart-updated', 'shopify:section:load'].forEach(function (naam) {
      document.addEventListener(naam, function (e) {
        setTimeout(function () { ververs(e.target && e.target.querySelectorAll ? e.target : document); }, 0);
      });
    });
    var KEUZE_SEL = SEL + '[data-context="regel"],' + SEL + '[data-context="haak"]';
    /* B1 (sophior-bestelblad.js): de staat komt uit de DOM (extraPreorder), het
       event is alleen de aanleiding. */
    document.addEventListener('sophior:pakket-change', function () {
      Array.prototype.forEach.call(document.querySelectorAll(KEUZE_SEL), teken);
    });
    /* Huidige buybox (M2): een add-onvinkje of pakketkeuze laat de haak en de
       regel in dezelfde sectie opnieuw kiezen; de huidige buybox verstuurt geen
       sophior:pakket-change. */
    document.addEventListener('change', function (e) {
      var doel = e.target;
      if (!doel || !doel.closest) return;
      if (!doel.matches('[data-addon-checkbox]') && !doel.closest('[data-pakket]') && !doel.closest('[data-addon-block]')) return;
      var sectie = doel.closest('.shopify-section') || document;
      setTimeout(function () {
        Array.prototype.forEach.call(sectie.querySelectorAll(KEUZE_SEL), teken);
      }, 0);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v || !v.id) return;
        Array.prototype.forEach.call(document.querySelectorAll(SEL + '[data-varianten]'), function (n) {
          var m;
          try { m = JSON.parse(n.getAttribute('data-varianten') || '{}'); } catch (x) { m = {}; }
          if (!m[String(v.id)]) return;
          variantStaat.set(n, m[String(v.id)]);
          teken(n);
        });
      });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { ververs(drawer); }).observe(drawer, { childList: true, subtree: true });
    }
  }

  window.SophiorLeverdag = { staat: staat, ververs: ververs, bereken: bereken };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
